import { Check } from "lucide-react";

const items = [
  "Бесплатный выезд на замер",
  "Установка в течение 3 дней",
  "Работаем по Ташкенту",
  "Гарантия на изделия",
];

const TrustBlock = () => (
  <section className="px-4 md:px-0 -mt-4 md:-mt-8 relative z-10">
    {/* Premium thin trust strip */}
    <div className="mb-2.5 md:mb-3 rounded-full bg-foreground text-background px-4 md:px-6 py-2 text-center text-[10px] md:text-[11px] font-medium tracking-wide max-w-2xl mx-auto" style={{ boxShadow: "var(--shadow-elevated)" }}>
      <span className="opacity-90">Более 1000 довольных клиентов</span>
      <span className="opacity-40 mx-2 md:mx-3">·</span>
      <span className="opacity-90">Работаем с 1993 года</span>
      <span className="opacity-40 mx-2 md:mx-3">·</span>
      <span className="opacity-90">Собственное производство</span>
    </div>

    <div className="continuous-marquee compact-ribbon overflow-hidden rounded-lg border border-border/60 bg-card py-2.5" aria-label="Преимущества сервиса">
      <div className="continuous-marquee-track flex w-max gap-3 md:gap-4">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex shrink-0 items-center gap-7 md:gap-10" aria-hidden={copy === 1}>
            {items.map((text) => (
              <div key={`${copy}-${text}`} className="flex shrink-0 items-center gap-2">
                <div className="flex h-4.5 w-4.5 shrink-0 items-center justify-center rounded-full bg-primary/10">
                  <Check className="h-2.5 w-2.5 text-primary" strokeWidth={2.5} />
                </div>
                <span className="text-[11px] md:text-xs text-foreground/85 font-medium">{text}</span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default TrustBlock;
